"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var axios_1 = require("axios");
var models_1 = require("./models");
/**
 * Yoda API client
 */
var Yoda = /** @class */function () {
  /**
   * @param {String} apiKey
   */
  function Yoda(apiKey) {
    var headers = {};
    if (apiKey) headers['X-API-Key'] = apiKey;
    this.api = axios_1.default.create({
      baseURL: Yoda.API_END_POINT,
      timeout: 5000,
      headers: headers
    });
  }
  /**
   * Get a project changelog.
   *
   * Get all the releases of a project, optionnally from a
   * specific version (excluded).
   * It's also possible to include the released changes from
   * linked projects with the merge param.
   *
   * @param {String} projectId
   * @param {String} from (version number)
   * @param {String[]} merge : ids of linked projects to merge
   *
   * @return {ChangelogResponse}
   */
  Yoda.prototype.getChangelog = function (projectId, from, merge) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
      var url, publicUrl, result, status_1, statusText, data, error_1, _b, status_2, statusText;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            url = "/projects/".concat(projectId, "/changelog/");
            publicUrl = url;
            if (from) {
              url += "".concat(from);
              publicUrl += "from/".concat(from);
            }
            if (merge) {
              url += "/".concat(merge.join(','));
              publicUrl += "/merge/".concat(merge.join(','));
            }
            _c.label = 1;
          case 1:
            _c.trys.push([1, 3,, 4]);
            return [4 /*yield*/, this.api.get(url, {
              responseType: 'json'
            })];
          case 2:
            result = _c.sent();
            status_1 = result.status, statusText = result.statusText, data = result.data;
            return [2 /*return*/, {
              status: status_1,
              statusText: statusText,
              changelog: (_a = data.releases) === null || _a === void 0 ? void 0 : _a.map(function (r) {
                return new models_1.Release(r);
              }),
              changelogUrl: Yoda.PUBLIC_END_POINT + publicUrl
            }];
          case 3:
            error_1 = _c.sent();
            if (axios_1.default.isAxiosError(error_1)) {
              _b = error_1.response, status_2 = _b.status, statusText = _b.statusText;
              return [2 /*return*/, {
                status: status_2,
                statusText: statusText,
                error: error_1.toString()
              }];
            }
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/, {
              status: 500,
              statusText: 'An unknown error occured',
              error: 'An unknown error occured'
            }];
        }
      });
    });
  };
  /**
   * Production endpoint
   */
  Yoda.API_END_POINT = 'https://yoda.netoxygen.ch/api/v1';
  /**
   * Public endpoint
   */
  Yoda.PUBLIC_END_POINT = 'https://yoda.netoxygen.ch/public';
  return Yoda;
}();
exports.default = Yoda;